import { FC } from 'react';
import styled from 'styled-components';
import { CreateFormTheme } from '../../utils/themes';
import { useTheme } from '../../middleware/ThemeContext';
import CreateFormBackground from '../../assets/images/CreateFormBackground.png';

const FormTitleContainer = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundImage: `url(${CreateFormBackground})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundColor: theme.CreateFormTheme.colors.background,
  height: '80px',
  display: 'flex',
  alignItems: 'center', // Vertically center children
}));
const Title = styled('h2')(({ theme }) => ({
  fontSize: '22px',
  fontWeight: 600,
  fontFamily: "'Raleway', sans-serif",
  color: `${theme.CreateFormTheme.colors.primary} !important`,
  verticalAlign: 'middle',
  margin: 'auto 0',
}));

interface FormTitleComponentProps {
  title: string;
}

const FormTitle: FC<FormTitleComponentProps> = ({ title }) => {
  const { theme } = useTheme();
  return (
    <FormTitleContainer theme={theme}>
      <Title theme={theme}>{title}</Title>
    </FormTitleContainer>
  );
};

export default FormTitle;